import styled from '@emotion/styled'

export const LearningResourcesSectionWrapper = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  border-bottom: 5px dashed #ddd;
  margin-bottom: 70px;
`